<template>
    <b-card title="Filtros" class="d-print-none">
        <b-card-text>
            <b-row>
                <b-col cols="12" md="5">
                    <app-autocomplete
                        placeholder="Cliente"
                        :items="clients"
                        v-model="theClient"
                    />
                </b-col>
                <b-col cols="12" md="2">
                    <app-years-select-input
                        :label="false"
                        :placeholder="true"
                        v-model="filters.year"
                    />
                </b-col>
                <b-col cols="12" md="2">
                    <app-months-select-input v-model="filters.month" :label="false" :placeholder="true" />
                </b-col>
                <b-col cols="12" md="3">
                    <b-button variant="primary" :disabled="!validFilters" @click="$emit('filter', filters)"><i class="fa fa-filter"></i></b-button>
                    <b-button variant="primary" :disabled="!validFilters" @click="print"><i class="fa fa-print"></i></b-button>
                </b-col>
            </b-row>
        </b-card-text>
    </b-card>
</template>
<script>
import { mapGetters } from 'vuex';
import Autocomplete from '../../../../UI/Controls/AutocompleteV2/Autocomplete.vue';
import reportingRepository from '@repositories/reporting.repository';
export default {
    components: {
        appAutocomplete: Autocomplete
    },
    data(){
        return {
            filters: {
                clientId: '',
                year: '',
                month: ''
            },
            theClient: {}
        }
    },
    computed: {
        ...mapGetters(['clients']),
        validFilters(){
            return !Object.keys(this.filters).filter(key => !this.filters[key]).length;
        }
    },
    watch: {
        theClient(val){
            this.filters.clientId = val.id;
        }
    },
    methods: {
        print(){
            const rr = {...reportingRepository};
            rr.registerManagementReportDownload({
                clientId: this.filters.clientId,
                year: this.filters.year,
                month: this.filters.month
            });
            window.print();
        }
    },
}
</script>